export default {
  ScrollToField: {
    mounted() {
      this.handleEvent('scrollToField', ({ name }) => {
        const element = document.querySelector(`[data-field-slug="${name}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },
  },
};
